module.exports = __webpack_public_path__ + "static/media/uploadIcon.80014cd0.svg";